import { withErrorBoundary } from 'react-error-boundary';
import type { ContentfulArticleModel } from 'autogen/swagger/all';
import ContentCard from 'components/ContentCard';
import useMapToContentCardProps from '../../helpers/mapToContentCardProps';

function ArticleCardItem({ article, ...restProps }: { article: ContentfulArticleModel }) {
    const mappedProps = useMapToContentCardProps(article);

    if (!mappedProps || !article.link) return null;

    return <ContentCard {...mappedProps} key={article.link.url} {...restProps} isTransparent />;
}

export default withErrorBoundary(ArticleCardItem, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
